import { AfterViewInit, Component, ElementRef, HostListener } from '@angular/core';
import { UHFInteractionService } from '../../api/services';
import { WindowRef } from '../../common';

const MAX_WIDTH_EXTRA_SMALL = 767;
const UHF_BRAND_NAV = '.brandLogoNavWrapper';

@Component({
  selector: 'stay-mgmt-fixed-summary-container',
  templateUrl: './fixed-summary-container.component.html',
  styleUrls: ['./fixed-summary-container.component.scss']
})
/* If the price change summary is displayed and the user scrolls down on the page that section should also scroll.
   Viewports: S, M, L */
export class FixedSummaryContainerComponent implements AfterViewInit {
  private isXSVP: boolean;
  private stickyOn = false;
  private fixedStyle = <Object>null;
  private fixedPosition = false;
  private absolutePosition = false;
  private parentOffsetTop: number;
  private wrapperWidth: number;
  private wrapperHeight: number;
  private columnHeight: number;
  private progress = false;

  private debouncedWindowScroll: Function = this.debounce(() => { this.initSticky() }, 180);
  private debouncedWindowResize: Function = this.debounce(() => { this.windowResize() }, 60);

  constructor(private el: ElementRef, private win: WindowRef, private uhfService: UHFInteractionService) { }

  private debounce(func: () => void, wait = 50) {
    let time: any;
    return () => {
      clearTimeout(time);
      time = setTimeout(() => func(), wait);
    }
  }

  private queryBrandElement() {
    return this.win.nativeWindow.document.querySelector(UHF_BRAND_NAV);
  }

  private getUHFHeight(): number {
    const element = this.queryBrandElement();
    return (this.uhfService.isUHFPresent() ? element.getBoundingClientRect().height + element.parentElement.getBoundingClientRect().height : 0);
  }

  private getUHFBrandHeight(): number {
    return (this.uhfService.isUHFPresent() ? this.queryBrandElement().getBoundingClientRect().height : 0);
  }

  private getScrollY(): number {
    return this.win.nativeWindow.scrollY || (this.win.nativeWindow.pageYOffset || this.win.nativeWindow.document.documentElement.scrollTop);
  }

  isExtraSmallViewPort(): boolean {
    return (Math.max(this.win.nativeWindow.document.documentElement.clientWidth, this.win.nativeWindow.innerWidth || 0) <= MAX_WIDTH_EXTRA_SMALL);
  }

  private setOffsetTops() {
    this.parentOffsetTop = this.el.nativeElement.parentElement.parentElement.offsetTop;
  }

  private setWrapperWidth() {
    const value = this.el.nativeElement.parentElement.offsetWidth;
    if (value !== this.wrapperWidth) {
      this.wrapperWidth = value;
    }
  }

  private setFixedStyle() {
    this.fixedStyle = {'width.px': this.wrapperWidth, 'top.px': this.getUHFBrandHeight()};
  }

  private initSticky() {
    if (this.isXSVP) {
      // Just let continues the flow
    } else if (this.wrapperHeight >= this.columnHeight) {
      this.removeSticky();

    } else if (this.stickyOn) {
      this.runSticky();
    }

    if (this.progress) { this.progress = false; }
  }

  private runSticky() {
    const scrollY = this.getScrollY();
    const uhfHeight = this.getUHFHeight();

    if (scrollY >= (this.columnHeight + (this.parentOffsetTop + uhfHeight) - this.win.nativeWindow.innerHeight)) {
      if (!this.absolutePosition) { this.absolutePosition = true; }
      if (this.fixedPosition) {
        this.fixedPosition = false;
        this.fixedStyle = null;
      }

    } else if (scrollY - (this.el.nativeElement.parentElement.getBoundingClientRect().top + uhfHeight + (uhfHeight - this.getUHFBrandHeight())) > 0) {
      if (!this.fixedPosition) {
        this.fixedPosition = true;
        this.setFixedStyle();
      }
      if (this.absolutePosition) { this.absolutePosition = false; }

    } else {
      this.removeSticky();
    }
  }

  private removeSticky() {
    if (this.absolutePosition) { this.absolutePosition = false; }
    if (this.fixedPosition) { this.fixedPosition = false; }
    if (this.fixedStyle) { this.fixedStyle = null; }
  }

  private windowResize() {
    const isXS = this.isExtraSmallViewPort();
    this.setOffsetTops();

    if (isXS && !this.isXSVP) {
      this.isXSVP = true;
      this.removeSticky();

    } else if (!isXS && this.isXSVP) {
      this.isXSVP = false;
      this.initSticky();

    } else if (!isXS && !this.isXSVP) {
      this.setWrapperWidth();
      if (this.fixedPosition) { this.setFixedStyle(); }
    }

    if (this.progress) { this.progress = false; }
  }

  private setTransition() {
    if (!this.progress && (this.fixedPosition || this.absolutePosition)) { this.progress = true; }
  }

  ngAfterViewInit(): void {
    this.isXSVP = this.isExtraSmallViewPort();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.isXSVP === void 0 || this.isXSVP) { return }
    this.setTransition();
    this.debouncedWindowScroll();
  }

  @HostListener('window:resize', [])
  onWindowResize() {
    this.setTransition();
    this.debouncedWindowResize();
  }

  contentHeight(event) {
    this.wrapperHeight = event;
    if (this.wrapperHeight > 0) { this.initSticky(); }
  }

  nextColumnHeight(event) {
    this.columnHeight = event;
    if (this.columnHeight > 0) { this.initSticky(); }
  }

  showSticky(event) {
    this.stickyOn = event;

    if (!this.isXSVP && this.stickyOn) {
      this.setOffsetTops();
      this.setWrapperWidth();
      this.initSticky();

    } else if (!this.stickyOn) {
      this.removeSticky();
    }
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/fixed-summary-container/fixed-summary-container.component.ts